export default __webpack_public_path__ + "images/HG.70d134a.png";